module.exports = __webpack_public_path__ + "static/media/travis-fischer.2eb56879.jpg";